import { ActionType } from '../../classes/action-type';
import { CalendarAppText, defaultText } from '../interfaces/calendar-app-text.state';
import { ICalendarStateAction } from '../interfaces/calendar-state.action';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function calendarTextReducer(state: CalendarAppText = defaultText, action: ICalendarStateAction) {
    switch (action.type) {
        case ActionType.ReceiveText: {
            return { ...state, ...action.value, requesting: false, apiError: null } as CalendarAppText;
        }
        default:
            return state;
    }
}
